export default class CountryModel {
    id: string = '';
    alias: string = '';
    countryCode = '';
    assets: {} = null;
    name: string = '';
}
